import { render, staticRenderFns } from "./addWasteOffer.vue?vue&type=template&id=33cefb23&scoped=true&"
import script from "./addWasteOffer.vue?vue&type=script&lang=js&"
export * from "./addWasteOffer.vue?vue&type=script&lang=js&"
import style0 from "./addWasteOffer.vue?vue&type=style&index=0&id=33cefb23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cefb23",
  null
  
)

export default component.exports